<template>
    <div class="accountDeliveryAddresses__container mx-auto">
        <div class="bg-white text-left border border-black pt-4">
            <div class="p-4">
                <div class="input">
                    <input
                        class="input__field text-center placeholder_color"
                        :placeholder="recipientPlaceholder"
                        type="text"
                        v-model="messageTo"
                        :maxlength="maxRecipientCharacters">
                </div>
                <div class="input">
                    <input
                        class="input__field text-center placeholder_color"
                        :placeholder="messageBodyPlaceholder"
                        type="text"
                        v-model="messageBody"
                        :maxlength="maxCharacters">
                </div>
                <div class="input">
                    <input
                        class="input__field text-center placeholder_color"
                        :placeholder="senderPlaceholder"
                        type="text"
                        v-model="messageFrom"
                        :maxlength="maxSenderCharacters">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftCardMessage',
    props: {
        forceClean: {
            default: false,
            type: Boolean,
        },
        defaultMessageBody: {
            default: 'GIFT_CARD_MESSAGE_THE_FLOWERS',
            type: String,
        },
    },
    data() {
        return {
            preRecipientText: this.$t('GIFT_CARD_MESSAGE_DEAR'),
            preSenderText: this.$t('GIFT_CARD_MESSAGE_LOVE'),
            messageRecipientText: '',
            messageBodyText: '',
            messageSenderText: '',
            maxRecipientCharacters: 30,
            maxCharacters: 250,
            maxSenderCharacters: 30,
        };
    },
    mounted() {
        if (!this.forceClean) {
            this.messageRecipientText = this.messageTo || '';
            this.messageBodyText = this.messageBody || '';
            this.messageSenderText = this.messageFrom || '';
        } else {
            this.messageTo = '';
            this.messageBody = '';
            this.messageFrom = '';
        }
    },
    beforeDestroy() {
        this.messageTo = this.messageTo ? this.messageTo.trim() : this.recipientPlaceholder;
        this.messageBody = this.messageBody ? this.messageBody.trim() : this.messageBodyPlaceholder;
        this.messageFrom = this.messageFrom ? this.messageFrom.trim() : this.senderPlaceholder;
    },
    computed: {
        messageBody: {
            get() {
                return this.$store.getters['gifting/getMessageBody'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageBody', value);
            },
        },
        messageTo: {
            get() {
                return this.$store.getters['gifting/getMessageTo'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageTo', value);
            },
        },
        messageFrom: {
            get() {
                return this.$store.getters['gifting/getMessageFrom'];
            },
            set(value) {
                this.$store.commit('gifting/updateMessageFrom', value);
            },
        },
        address() {
            return this.$store.getters['address/getSelectedGiftingAddress'];
        },
        firstName() {
            return this.$store.getters['account/getFirstName'];
        },
        recipientPlaceholder() {
            return `${this.preRecipientText} ${this.address?.first_name || ''},`;
        },
        messageBodyPlaceholder() {
            return this.$t(this.defaultMessageBody);
        },
        senderPlaceholder() {
            return `${this.preSenderText} ${this.firstName}`;
        },
    },
};
</script>
